export default __webpack_public_path__ + "src/assets/icn-new-wallet.91c8e99dd231936827c3a6f0cc4a8441.svg";